import styled from 'styled-components';
export const StyledA = styled.a`
    color: #3a3a3a;
`;
